import {isFacilityInactive} from "../../services/FacilityService";
import {SimpleFacilityModel} from "../../utils/types/facility";

type ReportingFacilitiesIdsParams = Readonly<{
  /** The ids reporting uses by default: the selected facilities, or every active facility */
  activeFacilitiesIds: ReadonlyArray<string> | null;
  /** The facilities selected in the header filter, null when nothing was selected */
  selectedFacilitiesIds: ReadonlyArray<string> | null;
  /** Every facility reporting uses, including the inactive ones kept in reporting */
  facilities: ReadonlyArray<SimpleFacilityModel>;
}>;

/**
 * Inactive facilities kept in reporting can't be selected in the header filter, so they come with their
 * organization: all of them without a selection, or the ones of the selected facilities' organizations.
 */
export const getReportingFacilitiesIds = ({
  activeFacilitiesIds,
  selectedFacilitiesIds,
  facilities,
}: ReportingFacilitiesIdsParams): string[] | null => {
  if (activeFacilitiesIds === null) {
    return activeFacilitiesIds as string[] | null;
  }

  const inactiveFacilities = facilities.filter(isFacilityInactive);

  const selectedOrganizationIds =
    selectedFacilitiesIds === null
      ? null
      : new Set(
          facilities
            .filter(facility => selectedFacilitiesIds.includes(facility.id))
            .map(facility => facility.organization.id),
        );

  const inactiveFacilitiesIds = inactiveFacilities
    .filter(
      facility =>
        selectedOrganizationIds === null ||
        selectedOrganizationIds.has(facility.organization.id),
    )
    .map(facility => facility.id);

  return Array.from(
    new Set([...activeFacilitiesIds, ...inactiveFacilitiesIds]),
  );
};
